export const environment = {
	production: true,
	cognitoUserPoolId: 'eu-central-1_zAGkiQocN',
	cognitoAppClientId: '1929se5er41fi5t1vthe13nfk4',
	redirectUri: '/adsignin',
	oAuthUri: 'https://auth.test.aciescore.com',
	awsEnvUri: 'https://api.test.aciescore.com',
	coreEnvironment: 'test',
	graphqlEndpoint: 'https://graphql.test.aciescore.com/graphql',
	IpLookupUri: 'https://api.ipify.org?format=json',
};
